<template>
    <v-col class="my-0 py-0 px-0 px-md-8 pb-15">
        <v-col class="text-start mt-5 mb-3">
            <v-alert text dense color="#8061c2" border="left" class="pl-5">
                <v-btn icon color="rgb(155 134 203)" to="/panel/admin/harmonys" class="mr-2">
                    <v-icon>mdi-keyboard-return</v-icon>
                </v-btn>
                <span class="title">Harmony:
                    <span class="text-capitalize">{{ siteName }}</span>
                </span>
                <p class="desc mt-0 mb-1">En esta sección podrás visualizar todas sus estadísticas</p>
            </v-alert>
        </v-col>

        <v-row class="d-block d-md-flex">
            <v-col class="col-12 col-md-4" v-if="siteId != 'all'">
                <div
                    class="profile d-flex text-left justify-space-around justify-md-center align-center px-5 py-6 rounded-xl fill-height">
                    <div class="d-flex flex-column justify-between">
                        <h4 class="wrap text-capitalize">{{ siteName }}</h4>
                        <p class="wrap">{{ this.statistics.site_info.description }}</p>
                    </div>
                    <img :src="statistics.site_info.logo_path ? statistics.site_info.logo_path : require('../../assets/illustrations/no-photo.jpg')"
                        alt="" width="100" height="100" class="rounded-pill" />
                </div>
            </v-col>
            <v-col class="col-12" :class="getAll">
                <div class="profile d-flex text-left justify-center align-center px-3 py-6 rounded-xl fill-height">
                    <v-row class="fill-height  justify-space-around justify-md-space-around">

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-col
                                    class="col-12 col-sm-5 col-md-2 px-4 d-flex flex-column justify-space-between pb-6 pt-0"
                                    v-bind="attrs" v-on="on">
                                    <v-container class="m-w mt-0  pa-md-0">
                                        <h4 class="number">{{ formatNumber(statistics.totals.total_visits) }}</h4>
                                        <p>{{ $t('Statistics.totalViews') }}</p>
                                        <v-progress-circular v-if="loading" indeterminate color="rgb(151, 138, 206)"
                                            class="mt-4" />
                                    </v-container>
                                    <v-icon v-if="!loading" class="icon pa-3 pa-md-0" size="40">mdi-eye-check</v-icon>
                                </v-col>
                            </template>
                            <span>{{ $t('Statistics.tooltip-totalViews') }}</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-col
                                    class="col-12 col-sm-5 col-md-2 px-4 d-flex flex-column justify-space-between pb-6 pt-0"
                                    v-bind="attrs" v-on="on">
                                    <v-container class="m-w mt-0  pa-md-0">
                                        <h4 class="number">{{ formatNumber(statistics.totals.unique_visits) }}</h4>
                                        <p>{{ $t('Statistics.uniqueViews') }}</p>
                                        <v-progress-circular v-if="loading" indeterminate color="rgb(151, 138, 206)"
                                            class="mt-4" />
                                    </v-container>
                                    <v-icon v-if="!loading" class="icon pa-3 pa-md-0" size="40">mdi-account-eye</v-icon>
                                </v-col>
                            </template>
                            <span>{{ $t('Statistics.tooltip-UniqueViews') }}</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-col
                                    class="col-12 col-sm-5 col-md-2 px-4 d-flex flex-column justify-space-between pb-6 pt-0"
                                    v-bind="attrs" v-on="on">
                                    <v-container class="m-w mt-0  pa-md-0">
                                        <h4 class="number">{{ formatNumber(statistics.totals.total_clicks) }}</h4>
                                        <p>{{ $t('Statistics.totalClicks') }}</p>
                                        <v-progress-circular v-if="loading" indeterminate color="rgb(151, 138, 206)"
                                            class="mt-4" />
                                    </v-container>
                                    <v-icon v-if="!loading" class="icon pa-3 pa-md-0"
                                        size="40">mdi-cursor-default-click</v-icon>
                                </v-col>
                            </template>
                            <span>{{ $t('Statistics.tooltip-TotalClicks') }}</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-col
                                    class="col-12 col-sm-5 col-md-2 px-4 d-flex flex-column justify-space-between pb-6 pt-0"
                                    v-bind="attrs" v-on="on">
                                    <v-container class="m-w mt-0  pa-md-0 m-auto">
                                        <h4 class="number">{{ formatNumber(statistics.totals.unique_clicks) }}</h4>
                                        <p>{{ $t('Statistics.totalClicksUniques') }}</p>
                                        <v-progress-circular v-if="loading" indeterminate color="rgb(151, 138, 206)"
                                            class="mt-4" />
                                    </v-container>
                                    <v-icon v-if="!loading" class="icon pa-3 pa-md-0"
                                        size="40">mdi-cursor-default-click</v-icon>
                                </v-col>
                            </template>
                            <span>{{ $t('Statistics.tooltip-TotalUniqueClicks') }}</span>
                        </v-tooltip>

                        <!-- estadisticas admin por usuario -->
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-col
                                    class="col-12 col-sm-5 col-md-2 px-4 d-flex flex-column justify-space-between pb-6 pt-0"
                                    v-bind="attrs" v-on="on">
                                    <v-container class="m-w mt-0  pa-md-0 m-auto">
                                        <h4 class="number">${{ totalAmount }}</h4>
                                        <p>{{ $t('Statistics.totalEarnings') }}</p>
                                        <v-progress-circular v-if="loading" indeterminate color="rgb(151, 138, 206)"
                                            class="mt-4" />
                                    </v-container>
                                    <v-icon v-if="!loading" size="40"
                                        class="icon pa-3  pa-md-0">mdi-cash-multiple</v-icon>
                                </v-col>
                            </template>
                            <span>{{ $t('Statistics.tooltip-TotalEarnings') }}</span>
                        </v-tooltip>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <v-col class="chart rounded-xl mt-6">
            <v-row class="d-flex justify-end">
                <v-col cols="12" md="3">
                    <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="selectedStartMonth" :label="$t('Statistics.start-date')"
                                color="#8e84c0" filled prepend-inner-icon="mdi-calendar-start mt-3" readonly
                                v-bind="attrs" v-on="on" rounded dense></v-text-field>
                        </template>
                        <v-date-picker elevation="24" v-model="selectedStartMonth" @input="onStartMonthSelected"
                            :first-day-of-week="1" :locale="this.lang" color="#8e84c0" type="month"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="3">
                    <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="selectedEndMonth" :label="$t('Statistics.end-date')" color="#8e84c0"
                                filled prepend-inner-icon="mdi-calendar-end mt-3" readonly v-bind="attrs" v-on="on"
                                rounded dense></v-text-field>
                        </template>
                        <v-date-picker elevation="24" v-model="selectedEndMonth" @input="onEndMonthSelected"
                            :first-day-of-week="1" :locale="this.lang" type="month" color="#8e84c0"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select class="mr-12" :items="itemsRange" color="#8e84c0" filled :label="$t('Statistics.ranks')" dense
                        rounded v-model="selectedRange" @change="showSelectedRange"></v-select>
                </v-col>
                
                <!-- Date range indicator -->
                <v-col cols="12" class="pt-0">
                    <v-chip 
                        text-color="white" 
                        small
                        class="ma-4">
                        <v-icon left small>
                            {{ isUsingCustomDateRange ? 'mdi-calendar-range' : 'mdi-calendar-clock' }}
                        </v-icon>
                        {{ isUsingCustomDateRange ? 'Rango personalizado' : 'Rango predefinido' }}: {{ dateRangeText }}
                    </v-chip>
                </v-col>
            </v-row>
            <bar-chart class=" mx-auto mt-2 px-sm-12 px-5 pb-12 rounded-xl" :chart-data="chartData"></bar-chart>
        </v-col>

        <template>
            <!-- Data table for all sites -->
            <div cols="12" class="rounded-lg px-5 py-4 mt-7 rounded-xl chart">
                <h4 class="text-left">Enlaces con más clics</h4>
                <v-data-table :headers="tableHeaders" :items="linksMustClics" :loading="loading"
                     class="mt-4">
                    <template v-slot:item.platform="{ item }">
                        <v-icon class="pa-3 pa-md-0" color="gray" size="15">mdi-link</v-icon> &nbsp;
                        <a :href="item.url" target="_blank">
                        {{ item.platform  ? item.platform : item.url }}
                        </a>
                    </template>

                    <template v-slot:item.total="{ item }">
                        {{ formatNumber(item.total) }}&nbsp;
                        <v-icon class="pa-3 pa-md-0" color="gray" size="15">mdi-cursor-default-click</v-icon>
                    </template>
                </v-data-table>
            </div>
        </template>

        <!-- tabla conversiones -->
        <div cols="12" class="rounded-lg px-5 py-4 mt-7 rounded-xl chart">

            <div>
                <h4 class="text-center">Conversiones</h4>
                <p class="text-disabled mb-0" style="font-size: 14px;">
                    Total: ${{ getTotEarning(totalConversionsAmount) }} USD
                </p>

            </div>
            <v-row class="d-flex justify-center mt-0">
                <v-col class="pa-0 px-5 col-12 col-sm-6 col-md-3">
                    <v-select hide-details v-model="selectedConversions" :items="itemsForView" label="Ver"
                        @change="getConversions" color="#9BA9BD" class="mb-4 mt-6"></v-select>
                </v-col>
            </v-row>
            <v-data-table :headers="headersConversions" :items="conversions" :items-per-page="10"
                :loading="loadingConversions" class="mt-4">
                <template v-slot:item.platform="{ item }">
                    {{ item.platform }}
                </template>
                <template v-slot:item.platform_percent="{ item }">
                    {{ formatPercentage(item.platform_percent) }}
                </template>
                <template v-slot:item.payment_creator="{ item }">
                    {{ formatCurrency(item.payment_creator) }}
                </template>
                <template v-slot:item.payment_date="{ item }">
                    {{ formatDate(item.payment_date) }}
                </template>
            </v-data-table>
        </div>

        <div cols="12" class="rounded-lg px-5 py-4 mt-7 rounded-xl chart">
            <h4 class="text-center">Ganancias referidos</h4>
            <p class="text-disabled text-center" style="font-size: 14px;">
                Total: ${{tot_earnings}} USD
            </p>
            <v-data-table :headers="headersEarningsReferrals" :items="earnings_referrals" :items-per-page="10"
                :loading="loadingEarningsReferrals" class="mt-4">
                <template v-slot:item.total_amount="{ item }">
                    {{ formatDecimal(item.total_amount) }}
                </template>
                <template v-slot:item.ranges="{ item }">
                    {{ item.date_earning_referral }} &nbsp;al&nbsp; {{ item.date_earning_referral_end }}
                </template>
            </v-data-table>
        </div>

        <v-row no-gutters>
            <v-col class="chart rounded-xl mt-6">
                <bar-chart-percent class="mx-auto mt-2 px-sm-12 px-5 pb-12 rounded-xl"
                    :chart-data="chartPercent"></bar-chart-percent>
            </v-col>
        </v-row>

        <v-row class="pt-2">
            <v-col class="col-12 col-sm-6 col-md-3" >
                <div class="pa-5 mt-4 pb-0 chart rounded-xl text-left">
                    <h4>{{ $t('Statistics.mostUsedDevices') }}</h4>
                    <doughnut-chart style="max-height:250px ; margin:auto;"
                        :doughnut-data="deviceStatsDataChart"></doughnut-chart>
                    <div>
                        <v-icon class="arrow" @click="deviceExpand = !deviceExpand"
                            :class="{ 'actived-arrow': deviceExpand }">mdi-play</v-icon>
                        <span class="show">{{ deviceExpand ? $t('Statistics.hide') : $t('Statistics.show_more')
                            }}</span>
                        <v-expand-transition>
                            <v-card v-show="deviceExpand" class="mx-auto chart" height="100" width="100">
                                <ul class="list">
                                    <li v-for="(item, index) in deviceStatsData" :key="item.device">
                                        <span :style="{ backgroundColor: deviceColors[index]}" class="color-box"></span>
                                        {{ item.device }}: {{ item.total }}
                                    </li>
                                </ul>
                            </v-card>
                        </v-expand-transition>
                    </div>
                </div>
            </v-col>
            <v-col class="col-12 col-sm-6 col-md-6">
                <div class="pa-5 pr-2  mt-4 pb-0 chart rounded-xl text-left " style="height: 323px;">
                    <h4>Países y regiones principales</h4>
                    <v-col cols="12" class="pa-0">
                        <v-tabs v-model="activeTab" color="#8e84c0" class="round-tab mb-3 d-flex justify-left ">
                            <v-tab v-for="(tab, index) in tabs" :key="index" class="custom-tab ">
                                {{ tab }}
                            </v-tab>
                        </v-tabs>
                    </v-col>

                    <v-col class="col-12 px-0 pb-2 mt-0 pt-0">
                        <v-responsive class="scroll-data pb-2">
                            <v-data-table v-show="activeTab === 0" :headers="headersCountry" :items="countryData"
                                :loading="loading" hide-default-footer disable-pagination>

                                <template v-slot:item.country="{ item }">
                                    <div class="item-container">
                                        <span>{{ item.country }}</span>
                                    </div>
                                </template>

                                <template v-slot:item.total="{ item }">
                                    <span>{{ formatNumber(item.total) }}</span>
                                </template>

                                <template v-slot:item.flag="{ item }">
                                    <v-img class="flags" :src="getCountryFlagUrl(item.country)" />
                                </template>

                                <template v-slot:item.percentage="{ item }">
                                    <v-chip color="#f4e8ff">
                                        {{ item.percentage }}%
                                    </v-chip>
                                </template>
                            </v-data-table>

                            <v-data-table v-show="activeTab === 1" :headers="headersRegion" :items="regionData"
                                hide-default-footer disable-pagination>
                                <template v-slot:item.total="{ item }">
                                    <span>{{ formatNumber(item.total) }}</span>
                                </template>
                            </v-data-table>
                        </v-responsive>
                    </v-col>
                </div>
            </v-col>

            <v-col class="col-12 col-sm-6 col-md-3">
                <div class="pa-5 mt-4 pb-0 chart rounded-xl text-left ">
                    <h4>{{ $t('Statistics.topCities') }}</h4>
                    <v-col class="col-12 px-0 pb-2 mt-0 pt-0">
                        <v-responsive class="scroll-data ">
                            <v-data-table :headers="headersCity" :items="cityData" :loading="loading"
                                hide-default-footer disable-pagination>
                                <template v-slot:item.total="{ item }">
                                    <span>{{ formatNumber(item.total) }}</span>
                                </template>
                            </v-data-table>
                        </v-responsive>
                    </v-col>
                </div>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import axios from "@/axios.js";
import { Bar, Doughnut } from "vue-chartjs";
import "chartjs-plugin-colorschemes";
import  { getCountryFlagUrl } from "@/utils/countries.js";

export default {
    name: "Statistics",
    components: {
        "bar-chart": {
            extends: Bar,
            props: ["chartData"],
            mounted() {
                this.renderChart(this.chartData, {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                precision: 0,
                            },
                        },
                    },
                });
            },
            watch: {
                chartData(newData) {
                    this.renderChart(newData, {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    precision: 0,
                                },
                            },
                        },
                    });
                },
            },
        },
        "doughnut-chart": {
            extends: Doughnut,
            props: ["doughnutData"],
            mounted() {
                this.renderChart(this.doughnutData, {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            padding: 0,
                            boxWidth: 10,
                        },
                    },
                });
            },
            watch: {
                doughnutData(newData) {
                    this.renderChart(newData, {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                            position: 'bottom',
                            labels: {
                                padding: 20,
                                boxWidth: 10,
                            },
                        },
                    });
                },
            },
        },
        "bar-chart-percent": {
            extends: Bar,
            props: ["chartData"],
            mounted() {
                this.renderChart(this.chartData, {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                max: 100,
                                callback: function (value) {
                                    return value + "%";
                                },
                            },
                        }],
                    },
                    title: {
                        display: true,
                        text: 'Tasa de Clics entre Visitantes Únicos'
                    }
                });
            },
            watch: {
                chartData(newData) {
                    this.renderChart(newData, {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    max: 100,
                                    callback: function (value) {
                                        return value + "%";
                                    },
                                },
                            }],
                        },
                        title: {
                            display: true,
                            text: 'Tasa de Clics entre Visitantes Únicos'
                        }
                    });
                },
            },
        }
    },
    data() {
        return {
            // Core data
            statistics: {
                totals: {
                    total_visits: 0,
                    unique_visits: 0,
                    total_clicks: 0,
                    unique_clicks: 0,
                },
                site_info: {
                    name: '',
                    description: '',
                    logo_path: null,
                },
            },
            
            // Chart data
            chartData: null,
            chartPercent: null,
            deviceStatsDataChart: null,
            deviceStatsData: null,
            deviceColors: null,
            deviceExpand: false,
            
            // Loading states
            loading: false,
            loadingConversions: false,
            loadingEarningsReferrals: false,
            
            // Route parameters
            siteId: this.$route.query.id || 'all',
            userId: this.$route.query.user_id || 'all',
            siteName: this.$route.query.name || 'todos',
            
            // Date filters
            selectedStartMonth: this.formatToYearMonth(new Date()),
            selectedEndMonth: this.formatToYearMonth(new Date()),
            selectedRange: 3,
            menuStart: false,
            menuEnd: false,
            lang: "es",
            
            // Geographic data
            countryData: [],
            regionData: [],
            cityData: [],
            activeTab: 0,
            tabs: ['Países', 'Regiones'],
            
            // Business data
            conversions: [],
            totalConversionsAmount: 0.00,
            totalSiteAmount: 0.00,
            selectedConversions: 0,
            earnings_referrals: [],
            totalEarningsReferrals: 0.00,
            tot_earnings: 0,
            linksMustClics: [],
            
            // Configuration
            itemsRange: [
                { text: 'Hoy', value: 0 },
                { text: 'Ayer', value: 1 },
                { text: 'Últimos 7 días', value: 2 },
                { text: 'Últimos 30 días', value: 3},
                { text: 'Este mes', value: 4 },
                { text: 'Mes anterior', value: 5 },
                { text: 'Este año', value: 6 },
                { text: 'Año anterior', value: 7 },
                { text: 'Desde siempre', value: 8 },
            ],
            itemsForView: [
                {text: 'Todos', value: 0},
                {text: 'Conversiones' , value: 1},
                {text: 'Leads', value : 2},
            ],
            
            // Table headers
            tableHeaders: [
                { text: "Platforma/URL", value: "platform" },
                { text: "Clicks", value: "total" },
            ],
            headersCountry: [
                { text: '', value: 'flag' },
                { text: 'Pais', value: 'country' },
                { text: 'Total', value: 'total' },
                { text: 'Porcentaje', value: 'percentage' },
            ],
            headersCity: [
                { text: 'Ciudad', value: 'city' },
                { text: 'Total', value: 'total' },
            ],
            headersRegion: [
                { text: 'Region', value: 'region' },
                { text: 'Total', value: 'total' },
            ],
            headersConversions: [
                { text: this.$t('conversions.platform'), value: 'platform' },
                { text: this.$t('conversions.percent'), value: 'platform_percent' },
                { text: this.$t('conversions.payment'), value: 'payment_creator' },
                { text: this.$t('conversions.date'), value: 'payment_date' },
            ],
            headersEarningsReferrals: [
                { text: 'Harmony', value: 'site_name', align: 'start' },
                { text: 'Creador', value: 'email', align: 'start' },
                { text: 'Ganacias', value: 'total_amount', align: 'start' },
                { text: 'Rango', value: 'ranges', align: 'start' },
            ],
        };
    },

    created() {
        this.$i18n.locale = 'es';
        this.checkLanguage();
        this.fetchAllData();
    },

    computed: {
        totalAmount() {
            const totalSiteAmount = parseFloat(this.totalSiteAmount) || 0;
            const totalConversionsAmount = parseFloat(this.totalConversionsAmount) || 0;
            const totalEarningsReferrals = parseFloat(this.totalEarningsReferrals) || 0;
            return (totalSiteAmount + totalConversionsAmount + totalEarningsReferrals).toFixed(2);
        },
        
        getAll() {
            return this.siteId == 'all' ? 'col-md-12' : 'col-md-8';
        },

        isUsingCustomDateRange() {
            return this.selectedRange === null || this.selectedRange === undefined;
        },

        dateRangeText() {
            if (this.isUsingCustomDateRange) {
                return `${this.selectedStartMonth} al ${this.selectedEndMonth}`;
            }
            return this.itemsRange[this.selectedRange]?.text || 'Seleccionar rango';
        },
    },
    methods: {
        // Utils
        getCountryFlagUrl,
        
        // Formatting methods
        formatDecimal(value) {
            const parts = value.toString().split('.');
            if (parts.length === 2 && parts[1].length > 2) {
                return parseFloat(parts[0] + '.' + parts[1].slice(0, 2));
            }
            return value;
        },

        formatCurrency(value) {
            return new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'USD',
            }).format(value);
        },

        formatDate(value) {
            return new Date(value).toLocaleDateString('es-ES');
        },

        formatPercentage(value) {
            return `${(value * 100).toFixed(0)}%`;
        },

        formatNumber(value) {
            if (value >= 1000000) {
                const millions = Math.floor(value / 100000) / 10;
                return millions + 'M';
            } else if (value >= 1000) {
                const thousands = Math.floor(value / 100) / 10;
                return thousands + 'k';
            } else {
                return value;
            }
        },

        formatToYearMonth(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        },

        getTotEarning(value){
            return value.toFixed(2)
        },

        // Event handlers
        showSelectedRange() {
            // When a predefined range is selected, reset custom dates to current month
            if (this.selectedRange !== null && this.selectedRange !== undefined) {
                const currentDate = new Date();
                this.selectedStartMonth = this.formatToYearMonth(currentDate);
                this.selectedEndMonth = this.formatToYearMonth(currentDate);
            }
            this.fetchAllData();
        },

        onStartMonthSelected(date) {
            this.selectedStartMonth = date;
            this.selectedRange = null; // Reset range when custom dates are selected
            this.menuStart = false;
            this.fetchAllData();
        },

        onEndMonthSelected(date) {
            this.selectedEndMonth = date;
            this.selectedRange = null; // Reset range when custom dates are selected
            this.menuEnd = false;
            this.fetchAllData();
        },

        checkLanguage() {
            const storedLocale = localStorage.getItem("locale");
            this.lang = storedLocale;
        },

        // Date range management
        resetToCurrentMonth() {
            const currentDate = new Date();
            this.selectedStartMonth = this.formatToYearMonth(currentDate);
            this.selectedEndMonth = this.formatToYearMonth(currentDate);
            this.selectedRange = 3; // Default to "Últimos 30 días"
            this.fetchAllData();
        },

        // Chart utilities
        generateRandomColors(count) {
            const baseColors = [
                "#FF6384", "#36A2EB", "#FFCE56", "#E57373", "#F06292",
                "#BA68C8", "#64B5F6", "#4FC3F7", "#81C784", "#FFD54F"
            ];

            const colors = [];
            for (let i = 0; i < count; i++) {
                if (i < baseColors.length) {
                    colors.push(baseColors[i]);
                } else {
                    const r = Math.floor(Math.random() * 256);
                    const g = Math.floor(Math.random() * 256);
                    const b = Math.floor(Math.random() * 256);
                    colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
                }
            }
            return colors;
        },

        // Main data fetching - Priority 1: Core statistics (blocking)
        async fetchAllData() {
            this.loading = true;
            try {
                await this.fetchCoreStatistics();
                this.prepareChartData();
                this.prepareChartPercent();
                
                // Priority 2: Secondary data (non-blocking, parallel)
                await Promise.all([
                    this.getlinksMustClics(),
                    this.getConversions(),
                    this.getUsersReferrals()
                   
                ]);
                
                // Priority 3: Business data (non-blocking, parallel)
                Promise.all([
                    this.loadGeographicData(),
                    this.getStatsDevices()
                ]);
                
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                this.loading = false;
            }
        },

        async fetchCoreStatistics() {
            const response = await axios.get("admin/site-statistics", {
                params: this.getRequestParams()
            });
            this.statistics = response.data;
            this.totalSiteAmount = this.statistics.totals.earnings.toFixed(2);
        },

        // Geographic data loading (parallel)
        async loadGeographicData() {
            await Promise.all([
                this.getStatsCountries(),
                this.getStatsCities(),
                this.getStatsRegions()
            ]);
        },

        async getlinksMustClics() {
            try {
                const response = await axios.get("admin/get-links-most-clicks", {
                    params: this.getRequestParams()
                });
                this.linksMustClics = response.data.data;
            } catch (error) {
                console.error("Error fetching links most clicks:", error);
            }
        },

        async getUsersReferrals(){
            this.loadingEarningsReferrals = true;
            try {
                const response = await axios.get('/admin/get-users-earnings-statistics', {
                    params: this.getRequestParams()
                });
                this.earnings_referrals = response.data.getUsersReferralsAdmin;
                this.tot_earnings = response.data.total.toFixed(2);
                
                this.totalEarningsReferrals = this.earnings_referrals.reduce((total, element) => {
                    return total + parseFloat(element.total_amount);
                }, 0);
            } catch (error) {
                console.error(error);
            } finally {
                this.loadingEarningsReferrals = false;
            }
        },

        async getConversions(){
            this.loadingConversions = true;
            try {
                const params = this.getRequestParams();
                params.type = this.selectedConversions; // Add conversion type filter
                
                const response = await axios.get("admin/admin-conversions", {
                    params: params
                });
                this.conversions = response.data.conversions;
                
                this.totalConversionsAmount = this.conversions.reduce((total, element) => {
                    return total + parseFloat(element.payment_creator);
                }, 0);
            } catch (error) {
                console.error('Error fetching conversions:', error);
            } finally {
                this.loadingConversions = false;
            }
        },

        // Geographic statistics
        async getStatsCountries() {
            try {
                const response = await axios.get('admin/get-countries-stats', {
                    params: this.getRequestParams()
                });
                this.countryData = response.data;
            } catch (error) {
                console.error('Error fetching country stats:', error);
            }
        },

        async getStatsRegions(){
            try {
                const response = await axios.get('admin/get-regions-stats', {
                    params: this.getRequestParams()
                });
                this.regionData = response.data;
            } catch (error) {
                console.error('Error fetching region stats:', error);
            }
        },

        async getStatsCities() {
            try {
                const response = await axios.get('admin/get-cities-stats', {
                    params: this.getRequestParams()
                });
                this.cityData = response.data;
            } catch (error) {
                console.error('Error fetching city stats:', error);
            }
        },

        async getStatsDevices(){
            try {
                const response = await axios.get('admin/get-devices-stats', {
                    params: this.getRequestParams()
                });
                this.deviceStatsData = response.data;

                const labels = this.deviceStatsData.map(item => item.device);
                const data = this.deviceStatsData.map(item => item.total);
                this.deviceColors = this.generateRandomColors(labels.length);

                this.deviceStatsDataChart = {
                    labels: labels,
                    datasets: [{
                        data: data,
                        backgroundColor: this.deviceColors,
                        borderWidth: 0.5,
                    }],
                };
            } catch (error) {
                console.error('Error fetching device stats:', error);
            }
        },

        // Helper method to get consistent request parameters
        getRequestParams() {
            const params = {
                site_id: this.siteId,
                user_id: this.userId,
                start_month: this.selectedStartMonth,
                end_month: this.selectedEndMonth,
            };
            
            // Only send selectedRange if it's not null and we're not using custom dates
            if (this.selectedRange !== null && 
                this.selectedRange !== undefined && 
                this.itemsRange[this.selectedRange]) {
                params.selectedRange = this.itemsRange[this.selectedRange].text;
            }
            
            return params;
        },

        // Chart preparation methods
        prepareChartData() {
            if (!this.statistics || !this.statistics.daily) return;
            const daily = this.statistics.daily;

            const labels = daily.map(item => item.date);
            const views = daily.map(item => Number(item.total_visits));
            const uniqueViews = daily.map(item => Number(item.unique_visits));
            const clicksUniques = daily.map(item => Number(item.unique_clicks));

            const createGradient = (ctx, top, bottom) => {
                const bgColor = [
                    "rgba(151, 138, 206, 0.6)",
                    "rgba(151, 138, 206, 0.4)",
                    "rgba(151, 138, 206, 0.2)",
                ];
                const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
                gradientBg.addColorStop(0, bgColor[0]);
                gradientBg.addColorStop(0.5, bgColor[1]);
                gradientBg.addColorStop(1, bgColor[2]);
                return gradientBg;
            };

            this.chartData = {
                labels,
                datasets: [
                    {
                        label: this.$t("Statistics.chart-views"),
                        backgroundColor: "rgba(66, 165, 245, 0.2)",
                        borderColor: "rgba(66, 165, 245, 1)",
                        borderWidth: 1,
                        data: views,
                        type: "bar",
                    },
                    {
                        label: this.$t("Statistics.chart-uniqueViews"),
                        backgroundColor: "rgba(102, 187, 106, 0.2)",
                        borderColor: "rgba(102, 187, 106, 1)",
                        borderWidth: 1,
                        data: uniqueViews,
                        type: "bar",
                    },
                    {
                        label: "Clics Unicos",
                        borderColor: "#978ace",
                        backgroundColor: (context) => {
                            if (!context.chart.chartArea) {
                                return;
                            }
                            const { ctx, chartArea: { top, bottom } } = context.chart;
                            return createGradient(ctx, top, bottom);
                        },
                        pointBackgroundColor: "#978ace",
                        pointBorderColor: "#978ace",
                        fill: true,
                        borderWidth: 1,
                        data: clicksUniques,
                        type: "line",
                    },
                ],
            };
        },

        prepareChartPercent() {
            const daily = this.statistics.daily;
            const labels = daily.map(item => item.date);
            const data = daily.map(item => item.ctr);

            this.chartPercent = {
                labels: labels,
                datasets: [{
                    label: '%',
                    data: data,
                    backgroundColor: 'rgba(151, 138, 206, 0.2)',
                    borderColor: 'rgba(151, 138, 206, 1)',
                    borderWidth: 1,
                    fill: false,
                }],
            };
        },
    },
};
</script>
<style scoped>
.v-icon.v-icon::after {
    width: 0px !important;
}

.v-container {
    max-width: 1200px;
    margin: 0 auto;
}

.scroll-data {
    height: 270px;
    overflow-y: auto;
}

.round-tab {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.custom-tab {
    text-transform: none;
    font-size: 12px;
    font-weight: 500;
    padding: 8px 16px;
}

::v-deep .v-chip__content{
    font-weight: 800;
    color: #8e84c0;
    font-size: 10px;
    height: 18px !important;
}

::v-deep .v-chip {
    height: 15px !important;
}

::v-deep .v-list-item__title{
    color: #8e84c0;
    font-weight: 600;
}

.flags {
    width: 21px;
}

.m-w {
    width: 100%;
    margin: 0;
    text-align: center
}

.heading h1 {
    font-size: 1.5rem;
    margin-bottom: 5px;
}

.heading p {
    font-size: 0.8rem;
    color: rgb(151, 138, 206);
    font-weight: 600;
}

.profile,
.chart {
    gap: 20px;
    color: rgb(70, 70, 70);
    -webkit-box-shadow: 0px 7px 16px 0px rgba(224, 224, 224, 1);
    -moz-box-shadow: 0px 7px 16px 0px rgba(224, 224, 224, 1);
    box-shadow: 0px 7px 16px 0px rgba(224, 224, 224, 1);
    overflow-y: hidden;
}

.profile p {
    font-size: 0.7rem;
    max-width: 250px;
    margin: auto;
}

.profile img {
    font-size: 0.8rem;
    object-fit: cover;
}

.number {
    font-size: 1.8rem;
    line-height: 1.2;
}

.icon {
    color: rgb(151, 138, 206);
}

.list {
    list-style: none;
    padding: 0;
    font-size: 12px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

.chartjs-render-monitor {
    max-height: 350px !important;
}

.color-box {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 10px;
    border-radius: 2px;
    margin-bottom: 2px;
}

.arrow {
    transform: rotate(90deg);
    padding: 0 !important;
    cursor: pointer;
    margin-bottom: 5px;
    border-radius: 50%;
    background-color: #c9b2ff;
    color: #8a72c1;
}

.actived-arrow {
    background-color: rgb(223, 223, 223);
    color: rgb(170, 170, 170);
}

.v-card {
    box-shadow: none !important;
    width: 100% !important;
    overflow: auto;
}

.show {
    margin-left: 5px;
    font-size: 0.7rem;
}

.wrap {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    overflow-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
}

.menu {
    width: 200px !important;
}
</style>